module.exports = __webpack_public_path__ + "static/media/tipolator2x.fd5ae3dc.png";